import 'core-js/stable';
import React, { FC, useEffect } from 'react';
import { isAndroid, isIOS } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import 'regenerator-runtime/runtime';
import RedirectToCustomHtmlOrFrame from 'src/components/base-components/RedirectToCustomHtmlOrFrame';
import { ROUTE_PATHS_TO_HTML } from 'src/utils/constants';
import { Logo } from './components/base-components/Logo';
import { Button } from './components/common/Button';
import ErrorBoundaryComponent from './hoc/ErrorBoundary';
import { I18nProvider } from './hoc/I18Provider';
import { Main } from './pages/Main';
import './styles/index.scss';

if (process.env.REACT_APP_MODE !== 'DEV' && process.env.REACT_APP_SMARTICO_ENABLE === 'true') {
  const script = document.createElement('script');
  script.src = 'https://libs.smartico.ai/smartico.js';
  script.onload = function () {
    // Initialize Smartico once the script is loaded
    (window as any)._smartico.init('93bab8d4-db19-4954-9f9e-094f9e5c5e01-3', { brand_key: 'ad714fa7' });
  };
  document.head.appendChild(script);
}

const App: FC = () => {
  const isEnableMaintenancePage = process.env.REACT_APP_MAINTENANCE_PAGE === 'true';
  const { t }: Translation = useTranslation();
  const pathname = window.location.pathname;

  useEffect(() => {
    if (isEnableMaintenancePage) {
      window.location.href = 'https://www.papipromopages.com/underconstruction';
    }
  }, [isEnableMaintenancePage]);

  if (isIOS) {
    // Create a meta tag element
    console.log('new version delivery');
    const viewportMetaTag = document.createElement('meta');

    // Set attributes for the meta tag
    viewportMetaTag.setAttribute('name', 'viewport');
    viewportMetaTag.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');

    // Append the meta tag to the head element of the document
    document.head.appendChild(viewportMetaTag);
  }

  const openInExternalBrowser = (url: string): void => {
    window.location.href =
      'intent://' +
      url.substr(url.indexOf('://') + 3) +
      '#Intent;scheme=' +
      url.substr(0, url.indexOf('://')) +
      ';package=com.android.chrome;end;';
  };

  if (isAndroid && navigator.userAgent.includes('Instagram')) {
    openInExternalBrowser(window.location.href);
    return (
      <div className="mobile_inst">
        <Logo />
        <Button size="lg" className="success-filled-btn" onClick={() => openInExternalBrowser(window.location.href)}>
          {t('playNow')}
        </Button>
      </div>
    );
  }

  return (
    <I18nProvider>
      <ErrorBoundaryComponent>
        {ROUTE_PATHS_TO_HTML.includes(pathname) ? <RedirectToCustomHtmlOrFrame /> : <Main />}
      </ErrorBoundaryComponent>
    </I18nProvider>
  );
};
export default App;
